import { Component, Input } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { ResidentialComplex } from '../../../core/models/home.model';

@Component({
  selector: 'app-complex-card',
  standalone: true,
  imports: [CommonModule, RouterLink, CurrencyPipe],
  template: `
    <div class="complex-card" [routerLink]="['/complexes', complex.id]">
      <div class="card-image">
        <img [src]="complex.mainImage" [alt]="complex.name" loading="lazy">
        <div class="status-badge">{{ complex.status }}</div>
      </div>
      <div class="card-content">
        <div class="price-info">
          <div class="main-price">{{ complex.minPrice | currency:'AZN':'symbol-narrow':'1.0-0' }}-dən</div>
          @if (complex.pricePerM2) {
            <div class="m2-price">{{ complex.pricePerM2 | currency:'AZN':'symbol-narrow':'1.0-0' }}-dən/m²</div>
          }
        </div>
        <h3 class="complex-name">{{ complex.name }}</h3>
        <div class="developer">{{ complex.developer }}</div>
        <div class="location">
          <i class="fas fa-map-marker-alt"></i> {{ complex.location }}
        </div>
      </div>
    </div>
  `,
  styles: [`
    .complex-card {
      background: #fff;
      border-radius: 16px;
      overflow: hidden;
      box-shadow: 0 4px 20px rgba(0,0,0,0.06);
      transition: all 0.3s ease;
      cursor: pointer;
      height: 100%;

      &:hover {
        transform: translateY(-8px);
        box-shadow: 0 12px 30px rgba(0,0,0,0.12);
      }
    }

    .card-image {
      position: relative;
      padding-top: 60%;
      overflow: hidden;

      img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .status-badge {
      position: absolute;
      bottom: 12px;
      right: 12px;
      background: rgba(255, 255, 255, 0.9);
      backdrop-filter: blur(4px);
      padding: 4px 12px;
      border-radius: 6px;
      font-size: 12px;
      font-weight: 600;
      color: #2d3436;
    }

    .card-content {
      padding: 16px;
    }

    .price-info {
      margin-bottom: 8px;
    }

    .main-price {
      font-size: 18px;
      font-weight: 800;
      color: #2ecc71;
    }

    .m2-price {
      font-size: 13px;
      color: #636e72;
    }

    .complex-name {
      margin: 8px 0 4px;
      font-size: 16px;
      font-weight: 700;
      color: #2d3436;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .developer {
      font-size: 13px;
      color: #636e72;
      margin-bottom: 8px;
    }

    .location {
      font-size: 13px;
      color: #b2bec3;
      display: flex;
      align-items: center;
      gap: 6px;
    }
  `]
})
export class ComplexCardComponent {
  @Input({ required: true }) complex!: ResidentialComplex;
}
